import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'modal',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.letters.push({
        document_template_id: null,
        recipient_id: null,
        task_id: null,
      })
    })
  }
}
